<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>学员管理</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- <div class="main-box">
      <queryStuBar @queryResult="queryHandle" />
    </div> -->

    <div class="tableList">
      <queryStuBar ref="refquery" @queryResult="queryHandle" />
      <div class="operBtn">
        <el-button type="primary" icon="plus" @click="addStu"
          >增加学员</el-button
        >
        <el-button type="primary" icon="document" @click="multyImport"
          >批量导入</el-button
        >
      </div>
      <el-table
        ref="multipleTable"
        :data="queryData"
        :header-cell-style="rowClass"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        v-loading.body="loading"
        id="Table"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="id" label="学员ID" align="center" width="110">
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewStu(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.id }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员昵称"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="viewStu(scope.row)"
              style="color: #1d90e6"
              >{{ scope.row.name }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="weixinId"
          label="微信号"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="家长手机号"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <a
              href="javascript:;"
              @click="filterByPhone(scope.row.phone)"
              style="color: #1d90e6"
              >{{ scope.row.phone }}</a
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="signupDate"
          label="报名时间"
          align="center"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop=""
          label="会员有效期"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.expireDate == '2121-01-01' ||
                scope.row.expireDate == null
              "
              style="color: red"
              >永久有效</span
            >
            <span v-else
              >{{
                checkTime(scope.row.expireDate)
                  ? scope.row.expireDate
                  : "已过期"
              }}
              {{ scope.row.expireTag }}
            </span>
            <!-- <span> {{scope.row.expireDate}}/{{scope.row.expireTag}} </span> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="学生状态"
          align="center"
          width="110"
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" type="warning">注册</el-tag>
            <el-tag v-else-if="scope.row.status == 1" type="gray">激活</el-tag>
            <el-tag v-else-if="scope.row.status == 2" type="success"
              >活跃</el-tag
            >
            <el-tag v-else-if="scope.row.status == 3" type="primary"
              >到期</el-tag
            >
            <el-tag v-else-if="scope.row.status == 4" type="danger"
              >注销</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          show-overflow-tooltip
          align="center"
          width="240"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="关联信息" placement="top">
              <el-button
                type="primary"
                size="mini"
                @click="viewStu(scope.row)"
                icon="el-icon-warning"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="操作日志" placement="top">
              <el-button
                type="primary"
                size="mini"
                @click="historyStu(scope.row)"
                icon="el-icon-document"
              ></el-button>
            </el-tooltip>
            <!-- <el-tooltip
              content="发送短信"
              placement="top"
              v-if="
                ($API.APPID == 'a2f98ac0af6d' ||
                  $API.APPID == '0ef550e27541') &&
                scope.row.isActive == false &&
                scope.row.status != 0 &&
                scope.row.status != 4
              "
            >
              <el-button
                type="primary"
                size="mini"
                @click="sendMsg(scope.row)"
                icon="el-icon-message"
              ></el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="btnFlex bottomOperBtn" style="margin-top: 20px">
        <el-button type="danger" @click="opStu('delete')" icon="delete2"
          >删除</el-button
        >
        <el-button type="success" @click="opStu('active')" icon="star-on"
          >激活</el-button
        >
        <el-button type="warning" @click="opStu('logout')" icon="caret-bottom"
          >注销</el-button
        >
        <stuAddExtra
          @extraResult="addExtraHandle"
          :len="multipleSelection.length"
          style="margin-left: 10px"
        />
        <stuChgExpire
          @chgExpire="chgExpireHandle"
          :len="multipleSelection.length"
          style="margin-left: 10px"
          >修改会员有效期</stuChgExpire
        >
      </div>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-sizes="[20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <Modal v-model="modalShow" width="960" footer-hide>
      <p slot="header" style="color: #f60; text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>资源列表文件格式样例</span>
      </p>
      <el-table
        ref="multipleTable2"
        :data="showData"
        stripe
        border
        tooltip-effect="dark"
        style="width: 100%; margin-bottom: 20px; font-size: 10px"
      >
        " >
        <el-table-column
          prop="id"
          label="*学员ID"
          align="center"
          width="90"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="*学员昵称"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="*电话"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="sex"
          label="*性别"
          align="center"
          width="70"
        ></el-table-column>
        <el-table-column
          prop="birthday"
          label="*出生日期"
          align="center"
          width="105"
        ></el-table-column>
        <el-table-column
          prop="signupTIme"
          label="*报名日期"
          align="center"
          width="105"
        ></el-table-column>
        <el-table-column
          prop="weixinId"
          label="微信号"
          align="center"
          width="105"
        ></el-table-column>
        <!-- <el-table-column
          prop="remark"
          label="备注"
          align="center"
          min-width="90"
        ></el-table-column> -->
        <el-table-column
          prop="effect"
          label="*学员有效期"
          align="center"
          min-width="105"
        ></el-table-column>
        <el-table-column
          prop="className"
          label="班级名称"
          align="center"
          min-width="90"
        ></el-table-column>
        <el-table-column
          prop="jionTime"
          label="入班时间"
          align="center"
          min-width="90"
        ></el-table-column>
        <el-table-column
          prop="rateTeacherId"
          label="定级老师"
          align="center"
          width="105"
        ></el-table-column>
        <!-- <el-table-column
          prop="renewalTeacherId"
          label="拉群续费号"
          align="center"
          width="105"
        ></el-table-column> -->
      </el-table>
      <p>（1）样例中的所有列必须按顺序全部存在</p>
      <p>（2）加*为必填项</p>
      <p>（3）学员id为0表示新增，非0为编辑</p>
      <p>（4）excel格式为xlsx</p>
      <el-upload
        action="/edu/eduAdmin/stu/import"
        accept=".xlsx, .xls"
        :before-upload="onBeforeUpload"
        :on-success="onSuccessUpload"
        :on-error="onErrorUpload"
        :data="uploadData"
        :show-file-list="true"
        style="margin-top: 20px"
      >
        <el-button size="small" type="primary">
          立即导入
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-upload>
      <div v-if="uploadResult != null">
        <p>导入学员总数:{{ uploadResult.total }}</p>
        <p>导入成功数量:{{ uploadResult.succ }}</p>
        <p>导入失败数量:{{ uploadResult.fail }}</p>
        <p
          style="color: red; margin-top: 10px; margin-bottom: 10px"
          v-if="uploadResult.succ != 0"
        >
          注：表格中第{{
            uploadResult.succ + 1
          }}行之前数据已经导入成功，请勿重复导入，再次上传请在表格中删除！
        </p>
      </div>
      <!-- 信息表格 -->
      <el-table
        ref="multipleTable2"
        :data="badResult"
        stripe
        border
        tooltip-effect="dark"
        style="width: 100%; margin-bottom: 20px; font-size: 10px"
        v-if="badResult != null"
      >
        <el-table-column
          prop="row"
          label="行数"
          align="center"
          width="200px"
        ></el-table-column>
        <el-table-column
          prop="field"
          label="出错字段"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="出错原因"
          align="center"
        ></el-table-column>
      </el-table>
    </Modal>
    <!-- 注销弹框 -->
    <Modal v-model="logoutShow" width="470" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <!-- <span>
          <slot></slot>
        </span> -->
        <span>需要清除的数据</span>
      </p>
      <el-form
        :inline="true"
        :model="formStu"
        label-width="100px"
        style="margin-left: 30px"
      >
        <el-form-item label="">
          <el-checkbox-group v-model="formStu.deleteOptions">
            <el-checkbox label="course">班级关联课程</el-checkbox>
            <br />
            <el-checkbox label="extraCourse">特色课程</el-checkbox>
            <br />
            <el-checkbox label="studyRecord">学习记录</el-checkbox>
            <br />
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 276px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import queryStuBar from "../componentsEdu/queryStuBar";
import Bus from "@/utils/bus";
import {
  filterMultyNum,
  formatDateString,
  dateStrToMs1,
  dateStrToMs,
} from "../commonEdu";
import stuAddExtra from "../componentsEdu/stuAddExtra";
import stuChgExpire from "../componentsEdu/stuChgExpire";
export default {
  name: "stulist",
  components: { queryStuBar, stuAddExtra, stuChgExpire },
  data() {
    return {
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      formStu: {
        deleteOptions: [],
      },
      multipleSelection: [],
      modalShow: false,
      logoutShow: false,
      showData: [
        {
          id: 0,
          name: "小企鹅",
          signupTIme: "2020-12-1",
          birthday: "2012-12-1",
          sex: "男",
          phone: "13822222222",
          effect: "2021-5-31",
          className: "初级001",
          weixinId: "微信号",
          rateTeacherId: "emma",
          renewalTeacherId: "未泱机器人",
          jionTime: "2020-12-1",
        },
      ],
      // showbadData:[],
      uploadData: {
        appId: "",
        filename: "",
      },
      queryTerms: null,
      loading: true,
      uploadResult: null,
      badResult: null,
    };
  },
  props: {},
  created() {
    console.log(this.$API.APPID, "APPID");
  },
  computed: {},
  mounted() {
    let phone = sessionStorage.getItem("stuListFilterByPhone");
    if (phone != null) {
      sessionStorage.removeItem("stuListFilterByPhone");
      this.filterByPhone(phone);
    } else {
      this.fetchStuList();
    }
  },
  watch: {},
  methods: {
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    fetchStuList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
      };
      // console.log(this, 'thisdasd')
      // if (this.queryTerms != null) {
        //  console.log(this, 'thisdasd')
        if (this.$refs.refquery.formStu.id != "") {
          params.id = this.$refs.refquery.formStu.id;
        }
        if (this.$refs.refquery.formStu.stuName != "") {
          params.stuName = this.$refs.refquery.formStu.stuName ||this.$refs.refquery.stuName;
        }
        if (this.$refs.refquery.formStu.className != "") {
          params.className = this.$refs.refquery.formStu.className;
        }
        if (this.$refs.refquery.formStu.phone != "") {
          params.phone = filterMultyNum(this.$refs.refquery.formStu.phone);
        }
        if (this.$refs.refquery.formStu.weixinId != "") {
          params.weixinId = this.$refs.refquery.formStu.weixinId;
        }
        if (
          this.$refs.refquery.formStu.signupDate &&
          this.$refs.refquery.formStu.signupDate.length &&
          this.$refs.refquery.formStu.signupDate.length == 2
        ) {
          if (
            this.$refs.refquery.formStu.signupDate[0] != null &&
            this.$refs.refquery.formStu.signupDate[1] != null
          ) {
            params.signupDate = [
              formatDateString(this.$refs.refquery.formStu.signupDate[0]),
              formatDateString(this.$refs.refquery.formStu.signupDate[1]),
            ];
          }
        }
        if (
          this.$refs.refquery.formStu.expireDate &&
          this.$refs.refquery.formStu.expireDate.length &&
          this.$refs.refquery.formStu.expireDate.length &&
          this.$refs.refquery.formStu.expireDate.length == 2
        ) {
          if (
            this.$refs.refquery.formStu.expireDate[0] != null &&
            this.$refs.refquery.formStu.expireDate[1] != null
          ) {
            if (
              this.$refs.refquery.formStu.expireDate[0] == "2121-01-01" &&
              this.$refs.refquery.formStu.expireDate[1] == "2121-01-01"
            ) {
              params.expireDate = ["", ""];
            } else {
              params.expireDate = [
                formatDateString(this.$refs.refquery.formStu.expireDate[0]),
                formatDateString(this.$refs.refquery.formStu.expireDate[1]),
              ];
            }
          }
        }

        if (this.$refs.refquery.formStu.status !== null && this.$refs.refquery.formStu.status !== "") {
          params.status = this.$refs.refquery.formStu.status;
        }
      // }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      params.isNeedActive = true;
      // console.log(params, "params");
      this.eduAxiosPostRequest("/edu/eduAdmin/stu/list", params).then((res) => {
        if (res != null) {
          let m = JSON.parse(res);
          this.queryData = m.list;
          this.pageTotal = m.pager.total;
        }
        this.loading = false;
      });
    },
    addStu() {
      this.$router.push({
        name: "addStu",
      });
    },
    multyImport() {
      this.modalShow = true;
    },
    queryHandle(param) {
      // debugger
      this.queryTerms = param;
      this.queryParams.page = 1;
      this.fetchStuList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(stu) {
      this.$router.push({
        name: "addStu",
        query: {
          id: stu.id,
          status: stu.status,
        },
      });
    },
    // 操作日志
    historyStu(stu) {
      this.$router.push({
        name: "stuHistory",
        query: {
          id: stu.id,
          name: stu.name,
        },
      });
    },
    // 发送短信
    // sendMsg(stu) {
    //   var stuIds = [];
    //   stuIds.push(`${stu.id}`);
    //   let params = {
    //     appId: this.$API.APPID,
    //     stuIds: stuIds,
    //     templateName: "inviteStudent",
    //   };
    //   console.log(params);
    //   // debugger
    //   this.eduAxiosPostRequest("/edu/eduAdmin/other/send_sms", params)
    //     .then((res) => {
    //       if (res != null) {
    //         this.$Message.success("短信发送成功!");
    //         this.fetchStuList();
    //       }
    //     })
    //     .catch((error) => {
    //       alert("短信发送失败，请用其他方式通知用户账号信息!");
    //       //  ApiMessage(this, error.toString(), "error");
    //     });
    // },
    viewStu(stu) {
      this.$router.push({
        name: "detailStu",
        query: {
          id: stu.id,
          status: stu.status,
        },
      });
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchStuList();
    },
    handleCurrentChange(val) {
      // debugger
      this.queryParams.page = val;
      this.$nextTick(() => {
        this.$forceUpdate();
        this.fetchStuList();
      });
    },
    onBeforeUpload(file) {
      this.uploadData.appId = this.$API.APPID;
      this.uploadData.filename = file.name;
    },
    onSuccessUpload(response, file, fileList) {
      if (response.rc == 0) {
        this.uploadResult = response.data;
        this.badResult = response.data.badList;
        // console.log(this.badResult)
        this.fetchStuList();
      } else {
        alert(response.err);
      }
    },
    onErrorUpload(err, file, fileList) {
      alert(err);
    },
    opStu(type) {
      // debugger
      if (this.multipleSelection.length == 0) {
        alert("请先选择学生");
        return;
      }
      if (type == "delete") {
        this.$Modal.confirm({
          title: "确认删除？",
          content: "<ul><li>请确认是否删除所选学生</li></ul>",
          onOk: () => {
            this.opStuSendRequset(type);
          },
        });
      }
      if (type == "logout") {
        // debugger;
        this.logoutShow = true;
        // this.opStuSendRequset1(type);
      } else if (type == "active") {
        this.opStuSendRequset(type);
      }
    },
    opStuSendRequset(type) {
      let stuIds = [];
      for (let i in this.multipleSelection) {
        stuIds.push(`${this.multipleSelection[i].id}`);
      }
      let params = {
        appId: this.$API.APPID,
        stuId: stuIds,
        action: type,
        // deleteOptions: this.formStu.deleteOptions,
      };
      // debugger;
      this.eduAxiosPostRequest("/edu/eduAdmin/stu/manage", params).then(
        (res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
            this.fetchStuList();
          }
        }
      );
    },
    filterByPhone(phone) {
      // debugger
      Bus.$emit("stuListFilterByPhone", {
        phone: phone,
      });
    },
    checkTime(timeCheck) {
      var myDate = new Date().toLocaleDateString();
      var now = dateStrToMs1(myDate);
      var time = dateStrToMs(timeCheck);
      // console.log(now);
      // console.log(time);
      if (now <= time) {
        return true;
      } else {
        return false;
      }
    },
    addExtraHandle(arr) {
      if (this.multipleSelection.length == 0) {
        alert("请先选择学生");
        return;
      }
      if (arr.length > 0) {
        let ids = [];
        for (let i in arr) {
          ids.push(String(arr[i].id));
        }
        let stuIds = [];
        for (let i in this.multipleSelection) {
          stuIds.push(`${this.multipleSelection[i].id}`);
        }
        let params = {
          appId: this.$API.APPID,
          stuId: stuIds,
          extraCourse: ids,
        };
        this.eduAxiosPostRequest(
          "/edu/eduAdmin/stu/extra_course_add",
          params
        ).then((res) => {
          if (res != null) {
            this.$Message.success("操作成功!");
              this.fetchStuList();

          }
        });
      }
    },
    modalCancel() {
      this.logoutShow = false;
    },
    modalConfirm() {
      let stuIds = [];
      for (let i in this.multipleSelection) {
        stuIds.push(`${this.multipleSelection[i].id}`);
      }
      let params = {
        appId: this.$API.APPID,
        stuId: stuIds,
        action: "logout",
        deleteOptions: this.formStu.deleteOptions,
      };
      this.eduAxiosPostRequest("/edu/eduAdmin/stu/manage", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            // debugger
            if (m.rc == 0) {
              // console.log(res.rc)
              // JSON.parse
              // debugger
              this.logoutShow = false;
              this.$Message.success("操作成功!");
              this.fetchStuList();
            }
          }
        }
      );
    },
    chgExpireHandle(val, selectValue) {
      // console.log(this.multipleSelection, "我要的数据");
      if (this.multipleSelection.length == 0) {
        alert("请先选择学生");
        return;
      }
      let stuIds = [];
      for (let i in this.multipleSelection) {
        stuIds.push(`${this.multipleSelection[i].id}`);
      }

      if (val == "") {
        alert("请选择有效期");
        return;
      } else if (selectValue == "" || selectValue == "请选择操作类型") {
        alert("请选择操作类型");
        return;
      } else {
        let params = {
          appId: this.$API.APPID,
          ids: stuIds,
          expireDate: val,
          expireOper: Number(selectValue),
        };
        this.$axios
          .post("/edu/eduAdmin/stu/batch_save", params)
          .then((response) => {
            if (response.data.rc == "0") {
              this.$Message.success("操作成功!");
              this.fetchStuList();
            } else if (response.data.rc == "-8") {
              alert("勾选的学生中存在永久有效的学员，请重新勾选！");
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          });
      }
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            if (response.data.rc == "0") {
              if (
                params.action != undefined ||
                address.indexOf("extra_course_add") != -1 ||
                address.indexOf("batch_save") != -1
              ) {
                resolve(JSON.stringify(response.data));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>
<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>



// WEBPACK FOOTER //
// stuList.vue?e2f18f5e